// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyC3w4TbqzlcyWgLh5LSuKdWEyirhAOnBpc',
    authDomain: 'bcvapp.firebaseapp.com',
    databaseURL: 'https://bcvapp.firebaseio.com',
    projectId: 'bcvapp',
    storageBucket: 'bcvapp.appspot.com',
    messagingSenderId: '363857411284',
    appId: '1:363857411284:web:66322a9d23b10983bbcf41',
    measurementId: 'G-20W1MRBFQP'
  },
  GoogleMapsApi: 'AIzaSyC3w4TbqzlcyWgLh5LSuKdWEyirhAOnBpc'
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
